// test2039
(2039 && 0);
